module.exports = __webpack_public_path__ + "static/img/index_01_11.f0bdd42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_01_11.png
// module id = gMTH
// module chunks = 3